import React, { useState } from "react";
import UseHandleBack from "@/hooks/UseHandleBack";
const SearchBar = () => {
	const handleBack = UseHandleBack("/");
	const [isOpenCurrency, setIsOpenCurrency] = useState(false);
	const [selectedCurrency, setSelectedCurrency] = useState("US Dollar");
	const [isOpenLocation, setIsOpenLocation] = useState(false);
	const [selectedLocation, setSelectedLocation] = useState({
		name: "Saudi Arabia",
		flag: "/assets/search/Icons/saudi.svg",
	});

	const locations = [
		{ name: "Saudi Arabia", flag: "/assets/search/Icons/saudi.svg" },
		{ name: "UAE", flag: "/assets/search/Icons/uae.svg" },
		{ name: "Qatar", flag: "/assets/search/Icons/qatar.svg" },
		{ name: "Kuwait", flag: "/assets/search/Icons/kuwait.svg" },
	];
	const currencies = ["US Dollar", "Euro", "British Pound", "Japanese Yen"];
	return (
		<div className="w-full h-[84px] p-[20px_30px] gap-[24px] bg-[#193D34] flex items-center hidden lg:flex">
			<div className="w-full h-[84px] p-[20px_30px] gap-[24px] bg-[#193D34] flex items-center justify-center hidden lg:flex">
				<div
					className="w-[72px] h-[32px] flex items-center justify-between p-[8px]"
					onClick={handleBack}
				>
					<img
						loading="lazy"
						decoding="async"
						src="/assets/search/Icons/arrow.svg"
						alt="back"
						width={4}
						height={6}
						className="ml-1"
					/>
					<div className="w-[44px] h-[18px] text-[#E8ECEB] text-[13px] font-[500] leading-[24px] text-right flex items-center justify-end">
						Back
					</div>
				</div>

				<div className="w-full h-[44px] flex items-center rounded-[8px] border-[1.6px] border-gray-400 bg-white overflow-hidden left-[24px] hidden lg:flex">
					<input
						type="text"
						placeholder="Search product.."
						className="pl-4 w-full h-[40px] border-none bg-transparent text-black placeholder:text-gray-500 outline-none"
					/>
					<button className="w-[48px] h-[42px] flex items-center justify-center bg-[#B7D974] hover:bg-[#A9C864] transition-all">
						<img
							loading="lazy"
							decoding="async"
							src="/assets/home/topnav/search.png"
							alt="Search"
							className="w-[20px] h-[20px]"
						/>
					</button>
				</div>
				<div className="w-[241.86px] h-[38px] flex gap-[8px]">
					<div className="w-[241.86px] h-[38px] flex gap-[8px]">
						{/* First Main Div */}
						<div className="relative w-[126px] h-[36px] flex flex-col gap-[9px]">
							{/* Location Text */}
							<div className="w-[126px] h-[16px] text-[#B7D974] text-[13px] font-medium leading-[100%]">
								Location
							</div>

							{/* Location Details (Toggle) */}
							<div
								onClick={() => setIsOpenLocation(!isOpenLocation)}
								className="w-[109px] h-[16px] flex items-center gap-[4px] cursor-pointer"
							>
								<img
									loading="lazy"
									decoding="async"
									src={selectedLocation.flag}
									alt="Location"
									className="w-[16px] h-[16px]"
								/>
								<div className="w-[89px] h-[16px] text-[#F1F6E9] text-[13px] font-medium leading-[100%] whitespace-nowrap">
									{selectedLocation.name}
								</div>
							</div>

							{/* Dropdown Menu */}
							{isOpenLocation && (
								<div className="absolute top-[48px] w-[126px] bg-bgPrimary border border-[#B7D974] rounded-md z-10">
									{locations.map((location) => (
										<div
											key={location.name}
											onClick={() => {
												setSelectedLocation(location);
												setIsOpenLocation(false);
											}}
											className="w-[109px] h-[16px] flex items-center gap-[4px] px-2 py-1 cursor-pointer hover:bg-[#CFE6A2]"
										>
											<img
												loading="lazy"
												decoding="async"
												src={location.flag}
												alt={location.name}
												className="w-[16px] h-[16px]"
											/>
											<div className="w-[89px] h-[16px]  hover:text-black text-black  text-[13px] font-medium leading-[100%] whitespace-nowrap">
												{location.name}
											</div>
										</div>
									))}
								</div>
							)}
						</div>

						{/* Second Main Div */}
						<div className="relative w-[100px]">
							{/* Dropdown Toggle */}
							<div
								onClick={() => setIsOpenCurrency(!isOpenCurrency)}
								className="w-full h-[38px]  cursor-pointer rounded-[4px] px-2 flex flex-col justify-center gap-[4px]"
							>
								<div className="flex justify-between items-center h-[18px]">
									<span className="text-[#B7D974] text-[13px] font-medium">
										Currency
									</span>
									<img
										src="/assets/search/Icons/arrow_down.svg"
										alt="Toggle Dropdown"
										className={`w-[10px] h-[11.25px] transform ${isOpenCurrency ? "rotate-180" : ""}`}
									/>
								</div>
								<div className="text-[#F1F6E9] text-[13px] font-medium">
									{selectedCurrency}
								</div>
							</div>

							{/* Dropdown Menu */}
							{isOpenCurrency && (
								<div className="absolute top-[42px] w-full bg-bgPrimary border border-[#B7D974] rounded-md z-10">
									{currencies.map((currency) => (
										<div
											key={currency}
											onClick={() => {
												setSelectedCurrency(currency);
												setIsOpenCurrency(false);
											}}
											className="px-2 py-1 hover:bg-[#CFE6A2] hover:text-black text-black text-[13px] cursor-pointer"
										>
											{currency}
										</div>
									))}
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SearchBar;
